// extracted by mini-css-extract-plugin
export default {"modal":"modal_modal__ay5Ac","close":"modal_close__tT88Y","in":"modal_in__hfm5P"};